import createToggleListReducer from 'store/utils/toggleListReducer'

export default createToggleListReducer('expandedStyle')
